// 프론트엔드 날짜 유틸.
// API 는 'YYYY-MM-DD HH:mm:ss' (KST 벽시계) 문자열을 주고받는다.
// 브라우저 로컬 타임존에 흔들리지 않도록 문자열/필드 단위로 계산한다.

export function pad(n) {
  return String(n).padStart(2, '0');
}

// Date → 'YYYY-MM-DD' (로컬 필드 기준)
export function ymd(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

// 'YYYY-MM-DD' → Date (정오 기준, 경계 안전)
export function parseYmd(s) {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d, 12, 0, 0);
}

// 'YYYY-MM-DD HH:mm:ss' → { date:'YYYY-MM-DD', time:'HH:mm' }
export function splitDateTime(s) {
  if (!s) return { date: '', time: '' };
  const [d, t = '00:00:00'] = s.split(' ');
  return { date: d, time: t.slice(0, 5) };
}

// date('YYYY-MM-DD') + time('HH:mm') → 'YYYY-MM-DD HH:mm:00'
export function joinDateTime(date, time) {
  return `${date} ${time || '00:00'}:00`;
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function startOfWeek(date) {
  // 일요일 시작
  const d = new Date(date);
  return addDays(d, -d.getDay()); // 0=일 → 그 주 일요일로
}

export function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1, 12);
}

// 월 그리드(6주 x 7일) 날짜 배열 생성
export function monthGrid(date) {
  const first = startOfMonth(date);
  const gridStart = startOfWeek(first);
  const cells = [];
  for (let i = 0; i < 42; i++) cells.push(addDays(gridStart, i));
  return cells;
}

export const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'];
export const MONTH_LABEL = (d) => `${d.getFullYear()}년 ${d.getMonth() + 1}월`;

// 특정 날짜(YYYY-MM-DD)에 걸치는 이벤트 필터
export function eventsOnDay(events, dayStr) {
  return events.filter((e) => {
    const s = splitDateTime(e.start_at).date;
    const en = splitDateTime(e.end_at).date;
    return s <= dayStr && dayStr <= en;
  });
}
